import * as ActionTypes from '../actions/AppLogs';

const initialState = {
  appLogs: [],
  appLogsPage: 0,
  appLogsPages: 0,
  appLogsTotalElements: 0,
  appLogsInitialPage: 0,
  appLogsPageSize: 100,
  tableFilter: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_APP_LOGS.SUCCESS:
      return {
        ...state,
        appLogs: action.payload.content,
        appLogsPage: action.payload.currentPage,
        appLogsPages: action.payload.totalPages,
        appLogsTotalElements: action.payload.totalElements,
      };
    case ActionTypes.SET_APP_LOGS_PAGE:
      return { ...state, appLogsPage: action.payload };
    case ActionTypes.SET_APP_LOGS_PAGE_SIZE:
      return { ...state, appLogsPageSize: action.payload };
    case ActionTypes.SET_APP_LOGS_TABLE_FILTER:
      return { ...state, tableFilter: action.payload };
    default:
      return state;
  }
}
